export default __webpack_public_path__ + "static/media/SAML_Configuration_Step2.5c609ce6.png";